<script>
import appConfig from "@/app.config";
import Order from "../../../components/orderComponent"
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Bon de  Commande",
    meta: [{ name: "description", content: appConfig.description }]
  },

  components: { Layout,Order },

  props:{
    orderId:{
      type:Number,
      default:0
    },
  }
}

</script>

<template>
  <Layout>
     <Order :orderId=this.orderId />
  </Layout>
</template>